module.exports = __webpack_public_path__ + "assets/img/17794c83cda1fb69eab6fc12312a3883.png";